module.exports = __webpack_public_path__ + "img/deutsch.509a0ad8.svg";